export default "__VITE_ASSET__CcEM485f__"